import {useForm} from '@eitje/form'
import {FloatingTree} from '../../../floating'
import {SelectField} from './select_field'
import {SelectComponent} from './select_component'

const Inner = ({type = 'single', ...rest}) => {
	const {newForm} = useForm()

	if (newForm) return <SelectField type={type} {...rest} />

	return <SelectComponent type={type} {...rest} />
}

export const Select = props => {
	return (
		<FloatingTree>
			<Inner {...props} />
		</FloatingTree>
	)
}
